import { render, staticRenderFns } from "./PerformanceRevenuePanel.vue?vue&type=template&id=1c788aa8&scoped=true"
import script from "./PerformanceRevenuePanel.vue?vue&type=script&lang=js"
export * from "./PerformanceRevenuePanel.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRevenuePanel.vue?vue&type=style&index=0&id=1c788aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c788aa8",
  null
  
)

export default component.exports